import { useEffect } from 'react';
import { Link } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';
import { useCanEnterSurface } from '@/lib/platform/surfaces';
import { SURFACES } from '@/lib/gql/__generated__/surfaces';

export function NotFoundPage() {
  const canEnterBusTimes = useCanEnterSurface(SURFACES['bus-times']);
  useEffect(() => {
    const root = document.getElementById('root');
    root?.setAttribute('data-app-notfound', '1');
    return () => root?.removeAttribute('data-app-notfound');
  }, []);

  return (
    <main className="mx-auto flex min-h-screen max-w-xl flex-col justify-center gap-5 px-6">
      <p className="text-sm font-semibold tracking-widest text-muted-foreground">SEATTLE / BUS TIMES</p>
      <h1 className="text-4xl font-bold tracking-tight">This stop isn't on the board.</h1>
      <p className="text-muted-foreground">That page could not be found. Start again with a route and stop.</p>
      {canEnterBusTimes ? (
        <Button render={<Link to="/" />} className="w-fit">
          Go to bus times
        </Button>
      ) : null}
    </main>
  );
}
